import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import { setCurrentPage } from '../../../../../HotelDetails/hotelSlice';

export const useHotelSearch = ({
  disabled = false,
}: {
  disabled?: boolean;
}) => {
  const dispatch = useDispatch();
  const { sideFilters } = useSelector((state: RootState) => state.search);

  // Local state for search functionality
  const [hotelNameKeyWord, setHotelNameKeyWord] = useState('');
  const [debouncedSearchKeyWord, setDebouncedSearchKeyWord] = useState('');

  // Debounce hotel name search
  useEffect(() => {
    if (!hotelNameKeyWord || disabled) {
      return;
    }
    const handler = setTimeout(() => {
      setDebouncedSearchKeyWord(hotelNameKeyWord);
    }, 600);

    return () => clearTimeout(handler);
  }, [hotelNameKeyWord, disabled]);

  // Reset search when side filters change
  useEffect(() => {
    if (disabled) {
      return;
    }
    if (sideFilters) {
      handleHotelNameInputOnChange('');
    }
  }, [sideFilters, disabled]);

  const handleHotelNameInputOnChange = useCallback(
    (value: string) => {
      if (disabled) {
        return;
      }
      setHotelNameKeyWord(value);
      dispatch(setCurrentPage(1)); // Reset to first page

      if (!value) {
        setDebouncedSearchKeyWord('');
      }
    },
    [dispatch, disabled]
  );

  const clearSearch = useCallback(() => {
    if (disabled) {
      return;
    }
    setHotelNameKeyWord('');
    setDebouncedSearchKeyWord('');
  }, [disabled]);

  return {
    hotelNameKeyWord,
    debouncedSearchKeyWord,
    handleHotelNameInputOnChange,
    clearSearch,
  };
};
